import { render, staticRenderFns } from "./setDesp.vue?vue&type=template&id=970db4c0&"
import script from "./setDesp.vue?vue&type=script&lang=js&"
export * from "./setDesp.vue?vue&type=script&lang=js&"
import style0 from "./setDesp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports